import React from 'react';
import { Link } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';

const { VITE_HELP_CENTRE_URL } = getEnv();

export const faqsConfig = [
  {
    question: 'What makes Pata the right booking software for pet care businesses?',
    answer: () => (
      <>
        <p>
          Pata is built specifically for pet care businesses, from grooming salons and dog trainers to walkers, sitters
          and massage therapists. It helps manage bookings, reduce no-shows and attract new clients, all in one place.  
        </p>

        <p>
          Whether you’re just starting or already established, you get full access to a flexible booking platform
          without monthly fees, designed to help your business run and grow with ease.
        </p>
      </>
    ),
  },
  {
    question: 'Is Pata a good fit for all business sizes?',
    answer: () => (
      <>
        <p>
          Pata is built for pet care businesses of every size, from solo dog walkers and mobile groomers to dog
          trainers, behaviourists, hydrotherapy clinics and grooming salons. Whether you’re just starting out or
          managing multiple salons or clinics, Pata helps you take bookings, manage appointments and reduce no-shows.
        </p>

        <p>
          You’ll get access to the same powerful tools no matter your size, including online booking, automated
          reminders and calendar management. The platform is subscription-free and flexible, so you can grow at your own
          pace without monthly fees.
        </p>
      </>
    ),
  },
  {
    question: 'How can Pata help my pet business reduce no-shows?',
    answer: () => (
      <>
        <p>
          Pata helps reduce no-shows and cancellations with smart booking features designed for pet care businesses. You
          can request deposits or upfront payments using <Link to="/business/pata-pay">PataPay</Link>, which adds
          commitment from clients and protects your time.
        </p>

        <p>
          To keep your schedule full, Pata also offers automated reminders, waitlists, and smart scheduling, helping you
          fill gaps quickly with clients who are most likely to fill an empty time slot and spend less time chasing late
          or missed appointments.
        </p>
      </>
    ),
  },

  {
    question: 'What types of pet businesses can use Pata?',
    answer: () => (
      <>
        <p>
          Pata booking platform supports professionals across the pet care industry — from solo dog walkers and groomers
          to hydrotherapy clinics, dog trainers and sitters.
        </p>

        <p>Whatever pet care services you provide, Pata is designed to make life easier for professionals like you.</p>

        <p>
          Whether you provide pet grooming, dog walking, pet sitting, dog training, daycare, boarding, hydrotherapy,
          massage therapy or other services, Pata helps you take bookings, manage schedules, reduce no-shows and grow
          your business — all in one simple platform.
        </p>
      </>
    ),
  },
  {
    question: 'Do I need technical skills to use Pata?',
    answer: () => (
      <>
        <p>
          Not at all. Pata booking platform is designed to be simple and intuitive so you don’t need any technical
          skills to find your way around and start simplifying your admin.
        </p>

        <p>
          Whether you’re familiar with pen and paper diaries or another booking platform, setting up your business on
          Pata is quick and simple.
        </p>

        <p>
          If you do need help though, our dedicated support team is always on hand to answer your questions, and you can
          find lots of detailed information in our{' '}
          <a href={`${VITE_HELP_CENTRE_URL}`} target="_blank">
            Help Centre
          </a>
          .
        </p>
      </>
    ),
  },
  {
    question: 'Is Pata really subscription-free?',
    answer: () => (
      <>
        <p>
          Simply put, yes! Team Pata believes that every pet care business should have access to a booking platform that
          makes admin easy, so we made our subscription-free.
        </p>

        <p>
          With Pata, you get access to unlimited appointment bookings, client and email notifications, locations, and
          team members — all without any upfront or monthly fees.
        </p>

        <p>
          If you want to go further, extras like SMS top-ups and online or in-person payments are available — but
          they’re completely optional.
        </p>
      </>
    ),
  },
  {
    question: 'How does Pata Marketplace help promote pet care businesses?',
    answer: () => (
      <>
        <p>
          Joining Pata, you gain access to Pata Marketplace — a pet owners one-stop-shop for finding trusted local pet
          businesses.
        </p>

        <p>
          Pata Marketplace boosts your visibility online by helping pet owners discover pet care businesses when
          searching on Pata or Google for local pet services like grooming, walking, sitting, or training.
        </p>

        <p>
          Having a presence on Marketplace not only promotes your pet care business to local pet owners, but also helps
          grow your current network of loyal pet owners.
        </p>
      </>
    ),
  },
  {
    question: 'Can I migrate my data from my previous platform to Pata?',
    answer: () => (
      <>
        <p>
          Yes, if you’re currently using another booking platform, we can support you in migrating key data such as
          client details, appointments, services, and staff schedules into Pata’s booking platform.
        </p>
      </>
    ),
  },
];
